import { ModelNames } from '@reshub/model';

export class ETLMezoDto {
  modelType: ModelNames;
  object: any;
  objectId: string;
}
